<template>
    <FilterBase :title>
        <ThButton
            v-for="value in bounds"
            :key="value"
            v-qa="value"
            v-qa.filter-button
            v-qa.disabled="JSON.stringify(!!disabled)"
            :selected="isSelected(value)"
            :class="getClasses(value)"
            :disabled
            type="solid"
            size="small"
            @click="select(value)"
        >
            <span data-allow-mismatch="text">
                {{ formatter(value) }}
            </span>
        </ThButton>
    </FilterBase>
</template>

<script lang="ts" setup>
import FilterBase from '@/components/ui/filter/filters/layout/FilterBase.vue'
import ThButton from '@/components/ui/buttons/ThButton.vue'

interface Props {
    modelValue?: string[] | null
    bounds: string[]
    title?: string
    isMulti?: boolean
    formatter?: (v: string) => string
    disabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    modelValue: null,
    isMulti: true,
    formatter: (v: string) => v,
    title: undefined,
})

const emit = defineEmits<{
    'update:modelValue': [string[]]
}>()

const isSelected = (value: string): boolean => {
    if (!props.modelValue) {
        return false
    }

    return props.modelValue?.includes(value)
}

const getClasses = (value: string): Record<string, boolean> => ({
    button: true,
    selected: isSelected(value),
})

const updateModelValue = (value: string[]) => {
    emit('update:modelValue', value)
}

const select = (value: string) => {
    if (props.isMulti) {
        if (!props.modelValue) {
            updateModelValue([value])
        } else if (props.modelValue.includes(value)) {
            const model = props.modelValue.filter((v) => v !== value)

            updateModelValue(model)
        } else {
            const model = [...props.modelValue, value]

            updateModelValue(model)
        }
    } else {
        if (props.modelValue?.includes(value)) {
            updateModelValue([])
        } else {
            updateModelValue([value])
        }
    }
}
</script>

<style lang="scss" scoped>
:deep(.button) {
    margin: 0 10px 10px 0;

    &.small {
        padding: 7px 16px;
    }

    &.solid {
        background: transparent;
        color: $slate;
        border-color: $grey-300;

        &:hover {
            background: $grey-200;
            color: $slate;
        }
    }

    &.selected {
        border-color: $slate;
    }
}
</style>
